const metaTitle = {
  plans: 'eRank Plans — Find the perfect plan to grow your Etsy shop',
  free_trial_pro: 'eRank — Claim your 7-day free trial of the Pro plan',
  plans_basic: 'eRank — Subscribe to Basic',
};

const metaTags = [
  {
    name: 'description',
    content: 'Start using eRank for FREE and as your Etsy shop grows, upgrade to a paid plan to access even more data.',
  },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1.0',
  },
  {
    'http-equiv': 'X-UA-Compatible',
    content: 'ie=edge',
  },
  {
    'data-vue-meta': '1',
    vmid: 'description',
    name: 'description',
    content: 'eRank has three plans, great for beginners, intermediate, and advanced sellers on Etsy.',
  },
  {
    'data-vue-meta': '1',
    vmid: 'og:title',
    property: 'og:title',
    content: 'eRank Plans — Find the best plan for your Etsy shop',
  },
  {
    'data-vue-meta': '1',
    vmid: 'og:description',
    property: 'og:description',
    content: 'Start using eRank for FREE and as your Etsy shop grows, upgrade to a paid plan to access even more data.',
  },
  {
    'data-vue-meta': '1',
    vmid: 'og:site_name',
    property: 'og:site_name',
    content: 'eRank LTD',
  },
  {
    'data-vue-meta': '1',
    vmid: 'og:type',
    property: 'og:type',
    content: 'website',
  },
  {
    'data-vue-meta': '1',
    vmid: 'og:image',
    property: 'og:image',
    content: '/img/erank-meta.png',
  },
  {
    name: 'twitter:title',
    content: 'eRank Plans — Find the best plan for your Etsy shop',
    'data-vmid': 'twitter:title',
  },
  {
    name: 'twitter:description',
    content: 'Start using eRank for FREE and as your Etsy shop grows, upgrade to a paid plan to access even more data.',
    'data-vmid': 'twitter:description',
  },
  {
    name: 'twitter:image',
    content: '/img/erank-meta.png',
    'data-vmid': 'twitter:image',
  },
  {
    name: 'twitter:card',
    content: 'summary',
    vmid: 'twitter:card',
  },
  {
    name: 'p:domain_verify',
    content: '4a452b9edfa7318bd9a45fe0d20a25c0',
  },
  {
    name: 'google-site-verification',
    content: '-2cfMO7MeRJeifFFxsIOq3Ifssa2ai61ngBq40DYYkM',
  },
  {
    name: 'msvalidate.01',
    content: '65CFA6CFB407B1A92CCA3F3FB7B1D174',
  },
  {
    'http-equiv': 'Content-Type',
    content: 'text/html; charset= ISO-8859-1',
  },
];

export default [
  {
    path: '/plans',
    name: 'plans',
    component: () => import('@/modules/pricing/pages/Entry.vue'),
    meta: {
      metaTags,
      title: metaTitle.plans,
    },
  },
  // Trial page sunset: /pro redirects to /plans
  {
    path: '/pro',
    redirect: '/plans',
  },
  {
    path: '/basic',
    redirect: '/plans',
  },
];
